import { apiSlice } from './apiSlice';
import type { FAQResponse, FAQParams } from '@/types/api';

// FAQ API endpoints
export const faqApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET FAQ with optional query parameters
    getFAQ: builder.query<FAQResponse, FAQParams | void>({
      query: (params) => {
        const queryParams = new URLSearchParams();
        
        // Always add affiliate=true
        queryParams.append('affiliate', 'true');
        
        // Add optional search parameter
        if (params?.search) {
          queryParams.append('search', params.search);
        }
        
        // Add any other params (excluding type)
        Object.keys(params || {}).forEach((key) => {
          if (key !== 'type' && key !== 'search' && key !== 'affiliate') {
            queryParams.append(key, String(params![key]));
          }
        });
        
        const queryString = queryParams.toString();
        return `/api/faq${queryString ? `?${queryString}` : ''}`;
      },
      providesTags: ['FAQ'],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetFAQQuery,
  useLazyGetFAQQuery,
} = faqApi;
